export default {
    create_company: {
        create: 'Create Company',
    },

    create_practice: {
        heading: 'Please provide a practice location',
        button: 'Proceed',
    },

    reason_codes: {
        PROVIDER_PROFILE_INCOMPLETE: {
            heading: 'Profile Incomplete',
            message: 'Your profile is incomplete. Please complete your profile first.',
            button: 'Go to profile',
            action: 'GO_TO_PROFILE',
        },

        PRACTICE_SUBSCRIPTION_EXPIRED: {
            heading: 'Subscription Expired',
            message: 'Your practice subscription has expired. Please renew to continue.',
            button: 'Renew Subscription',
            action: 'GO_TO_BILLING',
        },

        INSURANCE_UNKNOWN_PROVIDER: {
            heading: 'Insurance Issue',
            message: 'The provider is not recognized by the selected insurance.',
            button: 'OK',
            action: null,
        },

        AUTH_REQUIRED: {
            heading: 'Authorization Required',
            message: 'Authorization is required before proceeding with this referral.',
            button: 'OK',
            action: null,
        },

        SERVICE_SCOPE_PARTIAL: {
            heading: 'Limited Service Availability',
            message: 'The provider only partially supports the requested services.',
            button: 'OK',
            action: null,
        },

        FAX_ONLY_PROVIDER: {
            heading: 'Fax Only Provider',
            message: 'This provider accepts referrals via fax only.',
            button: 'OK',
            action: null,
        },

        DELIVERY_REQUIRES_OUTREACH: {
            heading: 'Manual Outreach Required',
            message: 'This referral requires manual outreach to the provider.',
            button: 'OK',
            action: null,
        },

        NO_AVAILABILITY: {
            heading: 'No Availability',
            message: 'No available time slots were found for this provider.',
            button: 'OK',
            action: null,
        },

        INSURANCE_NOT_ACCEPTED: {
            heading: 'Insurance Not Accepted',
            message: 'The selected insurance is not accepted by this provider.',
            button: 'OK',
            action: null,
        },

        DISTANCE_TOO_FAR: {
            heading: 'Distance Too Far',
            message: 'The provider is located too far from the patient’s location.',
            button: 'OK',
            action: null,
        },

        PROVIDER_DECLINED_PREVIOUSLY: {
            heading: 'Previously Declined',
            message: 'This provider has previously declined this referral.',
            button: 'OK',
            action: null,
        },

        NO_AVAILABILITY_IN_TIMEFRAME: {
            heading: 'No Availability in Timeframe',
            message: 'No time slots are available within the requested timeframe.',
            button: 'OK',
            action: null,
        },

        PRACTICE_LOCATION_NOT_AVAILABLE: {
            heading: 'Location Not Available',
            message: 'The selected practice location is not available.',
            button: 'OK',
            action: null,
        },

        // UNMATCHABLE

        PROVIDER_NOT_IN_NETWORK: {
            heading: 'Out of Network',
            message: 'The provider is not part of your network.',
            button: 'OK',
            action: null,
        },

        PROVIDER_NOT_REGISTERED: {
            heading: 'Provider Not Registered',
            message: 'The provider is not registered on the platform.',
            button: 'OK',
            action: null,
        },

        PROVIDER_NOT_MEMBER_OF_PRACTICE: {
            heading: 'Not Part of Practice',
            message: 'The provider is not a member of the selected practice.',
            button: 'Create Practice',
            action: 'GO_TO_PRACTICE_CREATE',
        },

        PROVIDER_NOT_PHYSICIAN_OR_NP: {
            heading: 'Invalid Provider Type',
            message: 'The provider is not a physician or nurse practitioner.',
            button: 'OK',
            action: null,
        },

        PROVIDER_NOT_FOUND: {
            heading: 'Provider Not Found',
            message: 'The specified provider could not be found.',
            button: 'OK',
            action: null,
        },

        DEFAULT: {
            heading: 'Referral Info',
            message: 'Please review the referral details.',
            button: 'Done',
            action: null,
        },
    },
}
